/* ============================================================
   MUTE Cart-Drawer Additions — Phase 1.6.1
   Cross-Sell Add-to-Cart — Event-Delegation (Dawn-sicher)
   + Drawer-Bridge für [data-mute-cart-trigger]
   + Cart-Count-Badge-Updater

   Loaded via theme.liquid → läuft auch nach Dawns
   CartDrawer.renderContents() innerHTML-Replacement.
   ============================================================ */
(function () {
  'use strict';

  /* ----------------------------------------------------------
     1. Hilfsfunktion: Header-Cart-Badge aktualisieren
     ---------------------------------------------------------- */
  function updateCartBadge(count) {
    var badge = document.querySelector('[data-mute-cart-count]');
    if (!badge) return;
    badge.textContent = count > 0 ? count : '';
    if (count > 0) {
      badge.removeAttribute('hidden');
    } else {
      badge.setAttribute('hidden', '');
    }
  }

  /* ----------------------------------------------------------
     2. Bridge: [data-mute-cart-trigger] → Dawn CartDrawer.open()
        Dawn's setHeaderCartIconAccessibility() erwartet
        id="cart-icon-bubble" — wir brauchen das ID NICHT,
        weil wir den Drawer direkt ansteuern.
     ---------------------------------------------------------- */
  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('[data-mute-cart-trigger]');
    if (!trigger) return;
    var drawer = document.querySelector('cart-drawer');
    if (!drawer) return;
    e.preventDefault();
    if (typeof drawer.open === 'function') {
      drawer.open(trigger);
    } else {
      /* Fallback: Custom Event den Dawn selbst horcht */
      document.dispatchEvent(new CustomEvent('cart:open'));
    }
  });

  /* ----------------------------------------------------------
     3. Cross-Sell Add-to-Cart (Event-Delegation)
     ---------------------------------------------------------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.mute-cross-sell__add-btn');
    if (!btn) return;
    if (btn.classList.contains('is-loading')) return;
    if (btn.classList.contains('is-added')) return;

    var variantId = btn.dataset.variantId;
    if (!variantId) return;

    btn.classList.add('is-loading');

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: parseInt(variantId, 10), quantity: 1 }] })
    })
      .then(function (res) { return res.json(); })
      .then(function () {
        btn.classList.remove('is-loading');
        btn.classList.add('is-added');
        btn.innerHTML =
          '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="20 6 9 17 4 12"/></svg>';

        /* Dawn-Drawer aktualisieren + Badge updaten */
        fetch('/cart.js')
          .then(function (r) { return r.json(); })
          .then(function (cartData) {
            updateCartBadge(cartData.item_count);
            document.dispatchEvent(new CustomEvent('cart:refresh'));
            document.dispatchEvent(
              new CustomEvent('cart:update', { detail: cartData })
            );
          });
      })
      .catch(function () {
        btn.classList.remove('is-loading');
      });
  });

  /* ----------------------------------------------------------
     4. Badge-Sync bei jedem Dawn cart:update Event
        (z.B. wenn Dawn selbst den Drawer refresht)
     ---------------------------------------------------------- */
  document.addEventListener('cart:update', function (e) {
    if (e.detail && typeof e.detail.item_count === 'number') {
      updateCartBadge(e.detail.item_count);
    }
  });

  /* ----------------------------------------------------------
     5. Autoritative Badge-Sync nach jedem MUTE-Cart-Add
        (PDP-ATC + jeder Custom-Add dispatcht 'mute:cart:refresh').
        Dawn publiziert nur ueber ES-Modul-PubSub (nicht auf window),
        daher holen wir den echten Count direkt aus /cart.js.
     ---------------------------------------------------------- */
  function syncBadgeFromServer() {
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (cart && typeof cart.item_count === 'number') updateCartBadge(cart.item_count);
      })
      .catch(function () {});
  }
  document.addEventListener('mute:cart:refresh', syncBadgeFromServer);

})();
